import React, { useState, useEffect, useRef } from "react";
import Title from "../Title/Title";
import DescOne from "../DescOne/DescOne";
import DescTwo from "../DescTwo/DescTwo";
import Button from "../Button/Button";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./Result.module.scss";
import classNames from "classnames";
import { SITE_URL } from "../../state/consts";
import { IconButton, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { FacebookShareButton, WhatsappShareButton } from "react-share";

import { FacebookIcon, WhatsappIcon } from "react-share";

function Result({
  score,
  title,
  text,
  descOne,
  descTwo,
  imageSrc,
  posterContainer,
  optionsContainer,
  handlerBack,
}) {
  const [offset, setOffset] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [showConditions, setShowConditions] = useState(false);
  const textAreaRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ImageURL = SITE_URL + imageSrc;

  // кнопка скопировать
  const [open, setOpen] = useState(false);

  const testClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  function copyToClipboard(e) {
    textAreaRef.current.select();
    console.log(textAreaRef.current.value);
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess(
      <div className={styles.copySuccess}>O link foi copiado</div>,
    );

    setTimeout(() => {
      setCopySuccess(
        <div className={classNames(styles.copySuccess, styles.displayNone)}>
          O link foi copiado
        </div>,
      );
    }, "1500");
  }

  return (
    <>
      {!showConditions ? (
        <>
          <div className={posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={classNames(optionsContainer, styles.before)}>
            <div
              className={classNames({
                [styles.resultPosterContainer]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div className={styles.contentWrapper}>
                <div className={styles.score}>{score}</div>
                <Title value={title} />
                {text}
                <DescOne value={descOne} />
                <DescTwo value={descTwo} />
              </div>

              <div className={styles.promoBox}>
                <div className={styles.promoButtonsWrapper}>
                  <div className={styles.promoWrapper}>
                    <div className={styles.inputPromoWrapper}>
                      <form className={styles.form}>
                        <input
                          ref={textAreaRef}
                          value="HUTRI81"
                          className={styles.inputPromo}
                          readOnly
                        />
                      </form>

                      <button onClick={copyToClipboard} className={styles.copy}>
                        <ContentCopyIcon />
                      </button>
                    </div>
                  </div>

                  <div className={styles.buttonBox}>
                    <a
                      href="https://taximaxim.onelink.me/KKXl?pid=ID_Quiz&deep_link_value=maximzakaz%3A%2F%2F&deep_link_sub1=app%3Faction%3Dpromo%26code%3DHUTRI81&af_dp=maximzakaz%3A%2F%2Fapp%3Faction%3Dpromo%26code%3DHUTRI81&af_web_dp=https%3A%2F%2Ftaximaxim.com%2Fapp&c=PM4181160726"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        value="Terapkan kode promo"
                        className={styles.buttonPresent}
                      />
                    </a>

                    <Button
                      value="Ikuti kuis sekali lagi"
                      className={styles.buttonPresent}
                      onClick={handlerBack}
                      id="refresh"
                    />

                    <div
                      className={styles.buttonBoxLink}
                      onClick={() => {
                        setShowConditions(true);
                      }}
                    >
                      Ketentuan promosi
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classNames(
                  styles.contentWrapper,
                  styles.socialWrapper,
                )}
              >
                <Paragraph value="Bagikan kode promo" />
                <div className={styles.social}>
                  <FacebookShareButton
                    url={SITE_URL}
                    title="Ikuti kuis bertemakan sejarah Indonesia dan bawa pulang hadiah senilai Rp200.000 untuk perjalanan."
                    image={ImageURL}
                    hashtag="#Maxim"
                    id="facebook"
                  >
                    <FacebookIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.facebook)}
                    />
                  </FacebookShareButton>

                  <WhatsappShareButton
                    url={SITE_URL}
                    title="Ikuti kuis bertemakan sejarah Indonesia dan bawa pulang hadiah senilai Rp200.000 untuk perjalanan."
                    image={ImageURL}
                    id="whatsapp"
                  >
                    <WhatsappIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.whatsapp)}
                    />
                  </WhatsappShareButton>

                  <div id="sharelink">
                    <IconButton
                      onClick={testClick}
                      color="primary"
                      className={styles.share}
                    >
                      <ShareIcon />
                    </IconButton>
                    <Snackbar
                      message="Disalin ke papan kliping"
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                      autoHideDuration={1000}
                      onClose={() => setOpen(false)}
                      open={open}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {copySuccess}
        </>
      ) : (
        <>
          <div className={styles.posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={styles.resultContainer} m2>
            <div
              className={classNames({
                [styles.resultContainerBox]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div>
                <b>
                  <Paragraph value="Syarat dan Ketentuan Umum Maxim Quiz: «Hari Kemerdekaan RI»" />
                </b>
                <Paragraph value="Syarat dan Ketentuan Umum ini berlaku untuk penyelenggaraan Maxim Quiz: «Hari Kemerdekaan RI» dalam rangka memperingati Hari Kemerdekaan Republik Indonesia 81 yang diselenggarakan oleh Maxim Indonesia («Syarat dan Ketentuan»)." />
                <b>
                  <Paragraph value="Ketentuan Quiz" />
                </b>
                <ul>
                  <li>
                    <Paragraph value="Quiz ini terbuka bagi seluruh pengguna individu Maxim yang merupakan Warga Negara Indonesia, telah berusia minimal 18 (delapan belas) tahun pada saat mengikuti Quiz, atau bagi peserta yang berusia di bawah 18 (delapan belas) tahun dengan pendampingan dan bimbingan orang tua atau wali («Peserta»)." />
                  </li>
                  <li>
                    <Paragraph value="Quiz ini bertujuan untuk mengedukasi pengguna Maxim mengenai sejarah Indonesia, termasuk peristiwa-peristiwa penting, tokoh nasional, serta nilai-nilai kebangsaan yang membentuk perjalanan bangsa Indonesia dari masa ke masa." />
                  </li>
                  <li>
                    <Paragraph value="Peserta wajib mengikuti seluruh instruksi yang tersedia pada halaman Quiz." />
                  </li>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Peserta dinyatakan memenuhi persyaratan apabila:" />
                  </li>
                  <ul>
                    <li>
                      <Paragraph value="Menjawab pertanyaan Quiz dengan benar sebanyak mungkin; dan." />
                    </li>
                    <li>
                      <Paragraph value="Mematuhi seluruh ketentuan yang tercantum dalam Syarat dan Ketentuan ini." />
                    </li>
                  </ul>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Pemenang akan memperoleh kode promosi HUTRI81 («Kode Promosi») yang memberikan potongan harga sebesar 10% (sepuluh persen) dari total biaya perjalanan dengan nilai maksimum sebesar Rp200.000." />
                  </li>
                  <li>
                    <Paragraph value="Hadiah tidak dapat ditukar dengan uang tunai, tidak dapat dipindahtangankan, dan hanya berlaku bagi pemenang yang sah." />
                  </li>
                  <li>
                    <Paragraph value="Kode Promosi hanya dapat digunakan oleh pengguna baru atau pengguna yang belum melakukan pemesanan melalui aplikasi Maxim dalam 7 (tujuh) hari terakhir." />
                  </li>
                  <li>
                    <Paragraph value="Maxim Indonesia berhak mengganti hadiah dengan hadiah lain yang memiliki nilai setara apabila diperlukan." />
                  </li>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Maxim Indonesia berhak membatalkan keikutsertaan Peserta yang diduga:" />
                  </li>
                  <ul>
                    <li>
                      <Paragraph value="Memberikan data yang tidak benar atau menyesatkan;" />
                    </li>
                    <li>
                      <Paragraph value="Menggunakan identitas ganda atau akun palsu; atau" />
                    </li>
                    <li>
                      <Paragraph value="Melanggar Syarat dan Ketentuan ini maupun peraturan perundang-undangan yang berlaku." />
                    </li>
                  </ul>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Maxim Indonesia tidak berkewajiban memberikan penjelasan atau klarifikasi atas jawaban yang digunakan dalam Quiz." />
                  </li>
                  <li>
                    <Paragraph value="Penentuan identitas Peserta yang memenuhi persyaratan dan berhak menjadi pemenang sepenuhnya merupakan kewenangan Maxim Indonesia." />
                  </li>
                  <li>
                    <Paragraph value="Seluruh kewajiban perpajakan yang timbul atas hadiah menjadi tanggung jawab masing-masing pemenang sesuai dengan ketentuan peraturan perundang-undangan yang berlaku." />
                  </li>
                  <li>
                    <Paragraph value="Maxim Indonesia berhak melakukan verifikasi terhadap identitas dan keabsahan data Peserta sewaktu-waktu selama periode Quiz maupun setelah Quiz berakhir." />
                  </li>
                  <li>
                    <Paragraph value="Penentuan pemenang dilakukan oleh Tim Maxim Indonesia berdasarkan jumlah jawaban benar terbanyak. Apabila terdapat Peserta dengan jumlah jawaban benar yang sama, pemenang akan ditentukan berdasarkan waktu pengiriman jawaban tercepat." />
                  </li>
                  <li>
                    <Paragraph value="Keputusan Maxim Indonesia mengenai seluruh aspek penyelenggaraan Quiz, termasuk penentuan pemenang, bersifat final dan tidak dapat diganggu gugat." />
                  </li>
                </ul>

                <Button
                  className={styles.buttonConditions}
                  value="Kembali"
                  onClick={() => {
                    setShowConditions(false);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Result;
